import { ReactNode } from "react";

import { PaymentMethodOption, WalletType } from "common/types";
import { Optional } from "common/utils/types";

import PaymentMethod from "client/common/components/content/PaymentMethod";
import TextChip from "client/common/components/content/TextChip";

import { getPaymentOptionChargeabilityChip } from "../utils";

import styles from "../styles/PaymentMethodSelectPanelOption.module.less";

type PaymentMethodSelectPanelOptionProps = {
  method: PaymentMethodOption;
  status: ReactNode;
  otherExistingWallet: Optional<WalletType>;
};

const PaymentMethodSelectPanelOption = ({
  method,
  status,
  otherExistingWallet,
}: PaymentMethodSelectPanelOptionProps) => {
  const chargeabilityChip = getPaymentOptionChargeabilityChip(method);
  return (
    <div className={styles.option}>
      <PaymentMethod
        method={method}
        otherExistingWallet={otherExistingWallet}
        styles={{
          label: styles.number,
          description: styles.details,
        }}
      />
      {chargeabilityChip && (
        <TextChip className={styles.chargeabilityChip} variant={chargeabilityChip.variant} size="m">
          {chargeabilityChip.label}
        </TextChip>
      )}
      {status}
    </div>
  );
};

export default PaymentMethodSelectPanelOption;
